module.exports = __webpack_public_path__ + "static/media/norway_cord.a46b18ef.jpg";